export default "__VITE_ASSET__DTOwSfCB__"